class Singleton {
  static instance;
  listeners = new Set();

  _state;

  constructor(defaultValue = null) {
    this._state =
      typeof defaultValue === "boolean" ? defaultValue : defaultValue || {};
  }

  static getInstance() {
    if (!Singleton.instance) {
      Singleton.instance = new Singleton();
    }
    return Singleton.instance;
  }

  get state() {
    return this._state;
  }

  set state(newState) {
    this._state = newState;
    this.notifyListeners();
  }

  subscribe(listener) {
    this.listeners.add(listener);
  }

  unsubscribe(listener) {
    this.listeners.delete(listener);
  }

  notifyListeners() {
    this.listeners.forEach((listener) => listener());
  }
}

export default Singleton;

export const selectInstance = new Singleton();
export const isMenuDisabled = new Singleton(false);
